import { ThemeConfig, theme } from 'antd'

export const themeConfig: ThemeConfig = {
  token: {
    colorError: '#DA3600',
    colorInfo: '#312783',
    colorPrimary: '#312783',
    colorTextBase: '#000000',
    colorBgBase: '#f7f7fb',
    colorBgContainer: '#f7f7fb',
    fontFamily: 'Poppins, sans-serif',
    fontSize: 16,
  },
  components: {
    Layout: {
      footerBg: '#312783',
      colorBgBase: '#f7f7fb',
      headerBg: '#f5f5f5',
    },
    Input: {
      colorTextDescription: '#000000',
    },
    Slider: {
      colorText: '#000000',
      colorTextDescription: 'rgba(0,0,0,0.88)',
    },
    Carousel: {
      arrowSize: 64,
      arrowOffset: -64,
    },
  },
}

export const getDesignToken = () => {
  return theme.getDesignToken(themeConfig)
}

export const globalToken = getDesignToken()

// Export design system colors
export const colors = {
  // Primary Colors
  primary: '#312783',
  orange: '#DA3600',
  black: '#000000',

  // Secondary Colors
  purpleMid: '#7168B8',
  purpleLight: '#CFCBF4',

  // Neutral Colors
  neutral400: '#D9DBE9',
  neutral300: '#EFEFF6',
  neutral200: '#F7F7FB',
  neutral100: '#FFFFFF',
  white: '#FFFFFF',

  grey3: '#828282',
  grey1: '#EAEAEA',
}
